<!--投标详情-->
<template>
  <div class="bidding-details-container">
    <header-index/>
    <div class="bidding-details-content" :style="'min-height:'+min_height+'px;'">
      <!--面包削-切换导航栏-->
      <div class="bidding-details-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{path: '/outsourceDemand/index' }">交易大厅</el-breadcrumb-item>
          <el-breadcrumb-item :to="{path: '/outsourceDemand/mineBidding'}" v-if="from==1">我的招标</el-breadcrumb-item>
          <el-breadcrumb-item :to="{path: '/outsourceDemand/mineBid'}" v-if="from==2">我的投标</el-breadcrumb-item>
          <el-breadcrumb-item :to="{path: '/outsourceDemand/mineCollection'}" v-if="from==3">我的收藏</el-breadcrumb-item>
          <el-breadcrumb-item>招标详情</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row :gutter="16">
          <el-col :span="18">
            <div class="left-outsource">
              <span class="SourceHanSansCN">招标详情</span>
              <el-link @click="editCollection" plain :underline="false" v-if="biddingData.isFavorite==0">
                <i class="el-icon-star-off"/>
                <span class="el-link-span">收藏</span>
              </el-link>
              <el-link @click="editCollection" plain :underline="false" v-else>
                <i class="el-icon-star-on"/>
                <span class="el-link-span">已收藏</span>
              </el-link>
            </div>
            <div class="left-content">
              <div class="grid-content bg-purple">
                <i class="tag-1">
                  <span class="tag-red">招投标</span>
                  <span class="tag-white">{{ biddingData.money }}{{ biddingData.moneyUnit }}</span>
                </i>
                <i class="tag-2" v-if="biddingData.urgent==1">急</i>
                <i class="tag-2" v-if="biddingData.top==1">置顶</i>
                <p class="small-title SourceHanSansCN">{{ biddingData.title }}</p>
                <template v-if="bidSelectionList.length>0">
                  <div class="bidding-right-status" v-if="bidSelectionList[0].status!=-1 && bidSelectionList[0].uid==cid">
                    <!--状态（-1:未参与，0：参与中，1：投标成功，2：选标失败）-->
                    <i class="status-1" v-if="bidSelectionList[0].status==0"/>
                    <i class="status-2" v-if="bidSelectionList[0].status==1"/>
                    <i class="status-3" v-if="bidSelectionList[0].status==2"/>
                  </div>
                </template>
                <!--状态（1：参与中-->
                <template v-if="isShow">
                  <div class="bidding-right-status">
                    <i class="status-1"/>
                  </div>
                </template>
              </div>
              <div class="bg-bottom" >
                <p class="bottom-p">
                  <span class="left-span">
                  <i class="iconfont icon-clock"/>
                    {{ biddingData.statusFormat }}</span>
                  <span class="right-span">
                    <i class="iconfont icon-user"/>
                    {{ biddingData.nums }}人报名</span>
                </p>
              </div>
            </div>
            <div class="demand-details">
              <p class="demand-title">招标需求详情</p>
              <div class="details-info" v-html="biddingData.content"/>
            </div>
            <div class="demand-details" v-if="biddingData.appendix">
              <template v-if="biddingData.appendix!==undefined && biddingData.appendix!==null && biddingData.appendix.length>0">
                <p class="demand-title">附件</p>
                <p v-for="bid of biddingData.appendix" class="appendix" @click="handlePictureCardPreview(bid.url)">
                  <i class="iconfont icon-tupian"/>
                  <span>{{ bid.name }}</span>
                </p>
              </template>
            </div>
            <div class="demand-bottom" v-if="biddingData.uid!=cid">
              <el-button type="warning" @click="contactEmployer(biddingData)">联系雇主</el-button>
              <el-button type="danger" v-if="bidSelectionList.length<1 && isShow==false" @click="tenderOffer">投标报价</el-button>
            </div>
            <template v-if="bidSelectionList.length>0">
              <div  v-if="bidSelectionList[0].status!=-1 && bidSelectionList[0].uid!=cid" class="service-provider-list">
                <p class="demand-title">选中服务商</p>
                <el-row :gutter="16">
                  <el-col :span="12" v-for="bid of bidSelectionList">
                    <div class="grid-content bg-purple">
                      <el-row>
                        <el-col :span="4">
                          <el-image :src="bid.logo" fit="cover" style="width: 40px;height: 40px;border-radius: 50%"/>
                        </el-col>
                        <el-col :span="20">
                          <p class="small-title">
                            <span class="SourceHanSansCN user-name">{{ bid.name }}</span>
                          </p>
                          <p class="gray-p">
                            <span v-for="(lab,index) of bid.label" class="service-label">{{ lab }}</span>
                          </p>
                        </el-col>
                      </el-row>
                      <div class="bid-right-status">
                        <!--状态（-1:未参与，0：参与中，1：投标成功，2：选标失败）-->
                        <i class="status-1" v-if="bid.status==0"/>
                        <i class="status-2" v-if="bid.status==1"/>
                        <i class="status-3" v-if="bid.status==2"/>
                      </div>
                      <div class="grid-menu">
                        <div class="small-grid">
                          <p class="font-black">{{ bid.money }}{{ bid.moneyUnit }}</p>
                          <p class="font-gray">报价</p>
                        </div>
                        <div class="small-grid">
                          <p class="font-black">{{ bid.duration }}天</p>
                          <p class="font-gray">预计工期</p>
                        </div>
                        <div class="small-grid">
                          <p class="font-black">{{ bid.city }}</p>
                          <p class="font-gray">所在地区</p>
                        </div>
                      </div>
                      <p class="service-time">报价：{{ bid.time }}</p>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </template>
            <div v-if="serviceProviderList.length>0" class="service-provider-list">
              <p class="demand-title">投标服务商</p>
              <el-row :gutter="16">
                <el-col :span="12" v-for="service of serviceProviderList">
                  <div class="grid-content bg-purple" @click="seeMineBidding(service.tid)">
                    <el-row>
                      <el-col :span="4">
                        <el-image :src="service.logo" fit="contain" style="width: 40px;height: 40px;border-radius: 50%"/>
                      </el-col>
                      <el-col :span="20">
                        <p class="small-title">
                          <span class="SourceHanSansCN user-name">{{ service.name }}</span>
                        </p>
                        <p class="gray-p">
                          <span v-for="(label,index) of service.label" class="service-label">{{ label }}</span>
                        </p>
                      </el-col>
                    </el-row>
                    <div class="grid-menu">
                      <div class="small-grid">
                        <p class="font-black">{{ service.money }}{{ service.moneyUnit }}</p>
                        <p class="font-gray">报价</p>
                      </div>
                      <div class="small-grid">
                        <p class="font-black">{{ service.duration }}天</p>
                        <p class="font-gray">预计工期</p>
                      </div>
                      <div class="small-grid">
                        <p class="font-black">{{ service.city }}</p>
                        <p class="font-gray">所在地区</p>
                      </div>
                    </div>
                    <p class="service-time">报价：{{ service.time }}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="release-demand" @click="releaseDemand"></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <home_footer/>
    <Hang/>
    <el-dialog title="提示" :visible.sync="dialogVisible2" width="20%" class="dialog">
      <p>您还未认证企业，暂无法发布需求。</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="certifiedEnterprise">认证企业</el-button>
         <el-button @click="dialogVisible2=false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="20%" class="dialog">
      <p>您还未认证企业，暂无法投标报价。</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="certifiedEnterprise">认证企业</el-button>
         <el-button @click="dialogVisible=false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible3" width="20%" class="dialog">
      <p>您还未认证企业，暂无法发布需求。</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="certifiedEnterprise">认证企业</el-button>
         <el-button @click="dialogVisible3=false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible4" title="图片预览" width="550px">
      <el-image :src="dialogImageUrl" style="width: 500px;height: auto"/>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible5" width="20%" class="dialog">
      <p>雇主联系方式：{{biddingData.mobile}}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogVisible5=false">确定</el-button>
         <el-button @click="dialogVisible5=false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import home_footer from "@/components/footer/home_footer";
import headerIndex from "@/components/header/headerIndex";
import Hang from "@/components/Hang/Hang";
import {
  tendersDetails,
  biddingServiceProviderList,
  biddingCollect,
  selectedServiceProviderList
} from '@/api/cloudServiceApi'

export default {
  name: "biddingDetails",
  components: {headerIndex, home_footer, Hang},
  data() {
    return {
      min_height: document.documentElement.clientHeight - 315,
      id: 0,
      cid: 0,
      from: 0,
      biddingData: {},
      dialogVisible2: false,
      dialogVisible: false,
      dialogVisible3: false,
      serviceProviderList: [],
      bidSelectionList: [],
      personalInfo: {},
      isLoginThing:null,
      isShow:false,
      dialogVisible4:false,
      dialogImageUrl:'',
      dialogVisible5:false,
    }
  },
  methods: {
    /*招投标详情信息*/
    biddingDetails() {
      tendersDetails({
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        zid: this.id
      }).then(res => {
        if (res.code == 200) {
          this.biddingData = res.content;
        }
      })
    },
    /*发布需求*/
    releaseDemand() {
      /**
       * @param verified_type 认证类型（1：个人，2：政府，3：企业，4：媒体，5：其他）
       * @param state 认证状态（1：已认证。0未认证,2:审核中，-1：认证失败）
       */
      if (this.personalInfo.verified_type == 3 && this.personalInfo.state == 1) {
        this.$router.push({path: '/outsourceDemand/releaseDemand',})
      } else {
        this.dialogVisible3 = true;
      }
    },
    /*认证企业*/
    certifiedEnterprise() {
      this.dialogVisible2 = false;
      let routeData = this.$router.resolve({
        name: "enterpriseCertification",
        path: '/officialCloud/enterpriseCertification',
      });
      window.open(routeData.href, '_blank')
    },
    /*图片在线预览*/
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible4 = true;
    },
    /*招标收藏/取消收藏*/
    editCollection() {
      biddingCollect({
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        zid: this.id
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.biddingDetails();
        }
      })
    },
    /*判断文件类型*/
    matchFileType(fileName) {
      // 后缀获取
      let suffix = '';
      // 获取类型结果
      let result = '';
      if (!fileName) return false;
      try {
        // 截取文件后缀
        suffix = fileName.substr(fileName.lastIndexOf('.') + 1, fileName.length)
        // 文件后缀转小写，方便匹配
        suffix = suffix.toLowerCase()
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        result = false;
        return result;
      }
      let fileTypeList = [
        // 图片类型
        {'typeName': 'image', 'types': ['png', 'jpg', 'jpeg', 'bmp', 'gif']},
        // 文本类型
        {'typeName': 'txt', 'types': ['txt']},
        // excel类型
        {'typeName': 'excel', 'types': ['xls', 'xlsx']},
        {'typeName': 'word', 'types': ['doc', 'docx']},
        {'typeName': 'pdf', 'types': ['pdf']},
        {'typeName': 'ppt', 'types': ['ppt']},
        // 视频类型
        {'typeName': 'video', 'types': ['mp4', 'm2v', 'mkv']},
      ]
      for (let i = 0; i < fileTypeList.length; i++) {
        const fileTypeItem = fileTypeList[i]
        const typeName = fileTypeItem.typeName
        const types = fileTypeItem.types;
        result = types.some(function (item) {
          return item === suffix;
        });
        if (result) {
          return typeName
        }
      }
      return 'other'
    },
    /*获取投标服务商列表*/
    getBiddingServiceProviderList() {
      biddingServiceProviderList({
        page: 1,
        pageLimit: 20,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        zid: this.id
      }).then(res => {
        if (res.code == 200) {
          this.serviceProviderList = res.content.rows;
          if (res.content.rows.length>0){
            for (let rows of res.content.rows){
              if (this.cid==rows.uid){
                this.isLoginThing=rows;
                this.isShow=true;
              }
            }
          }
        }
      })
    },
    /*选中服务商列表*/
    getServiceProviderList() {
      selectedServiceProviderList({
        page: 1,
        pageLimit: 20,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        zid: this.id
      }).then(res => {
        if (res.code == 200) {
          this.bidSelectionList = res.content.rows;
        }
      })
    },
    /*投标报价*/
    tenderOffer() {
      /**
       * @param verified_type 认证类型（1：个人，2：政府，3：企业，4：媒体，5：其他）
       * @param state 认证状态（1：已认证。0未认证,2:审核中，-1：认证失败）
       */
      if (this.personalInfo.verified_type == 3 && this.personalInfo.state == 1) {
        this.$router.push({
          path: '/outsourceDemand/tenderOffer',
          query: {
            zid: this.biddingData.zid
          }
        })
      } else {
        this.dialogVisible = true;
      }

    },
    /*查看我的投标书*/
    seeMineBidding(tid){
      this.$router.push({
        path: '/outsourceDemand/bidingDoc',
        query: {
          tid: tid,
          zid: this.biddingData.zid
        }
      })
    },
    /*联系雇主*/
    contactEmployer(row){
      this.dialogVisible5=true;
    }
  },
  mounted() {
    this.biddingDetails();
    this.getBiddingServiceProviderList();
    this.getServiceProviderList();
  },
  beforeMount() {
    this.id = this.$route.query.id;
    this.from = this.$route.query.from;
    this.personalInfo = sessionStorage.getItem('personalInfo') != null && sessionStorage.getItem('personalInfo') != undefined && sessionStorage.getItem('personalInfo') != '' ? JSON.parse(sessionStorage.getItem('personalInfo')) : '';
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
  }
}
</script>
<style scoped>
.bidding-details-container >>> .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-weight: bold;
  color: #5D5D5D;
}

.bidding-details-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.bidding-details-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.bidding-details-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.bidding-details-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}

.bidding-details-container >>> .bidding-details-content .demand-bottom .el-button--warning {
  color: #FFF;
  background-color: #F6980E;
  border-color: #F6980E;
  font-size: 14px;
  border-radius: 0px;
}

.bidding-details-container >>> .bidding-details-content .demand-bottom .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  font-size: 14px;
  border-radius: 0px;
}
</style>
<style scoped lang="scss">
.bidding-details-container {
  background: #F5F5F5;

  .bidding-details-content {
    padding: 20px 18%;
    min-width: 76rem;
    background: #F5F5F5;
    .release-demand {
      background: url("~@/assets/img/cloud/releaseDemand.png") no-repeat;
      background-size: 100% 100%;
      height: 170px;
      cursor: pointer;
      margin-top: 20px;
    }

    .left-outsource {
      background: #ffffff;
      padding: 20px 40px;
      margin-top: 20px;
      border: 1px solid #EDEDED;
      display: flex;
      justify-content: space-between;

      .el-link-span {
        font-size: 16px;
        color: #333333;
        font-family: SourceHanSansCN;
      }

      .el-icon-star-off {
        opacity: 0.6;
        font-size: 18px;
      }

      .el-icon-star-on {
        font-size: 18px;
        color: #FE273B;
        opacity: 1;
      }
    }

    .left-content {
      background: #ffffff;
      padding: 30px 40px;

      .bg-purple {
        background: #F3F9FF;
        padding: 30px 20px 20px;

        .small-title {
          color: #333333;
          font-size: 20px;
          text-align: left;
          margin-block-end: 0em;
          padding-top: 10px;
          /*overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          word-break: break-all;*/
          cursor: pointer;

          .user-name {
            font-size: 16px;
            color: #333333;
          }

          .el-position {
            font-style: normal;
            font-size: 12px;
            color: #ffffff;
            background: #FF9600;
            padding: 3px 5px;
            border-radius: 4px;
            margin-left: 10px;
          }

          .right-icon {
            float: right;
            width: 30px;
            height: 30px;

            .icon-phone {
              background: url("~@/assets/img/cloud/dianhua.png");
              width: 30px;
              height: 30px;
              background-size: 100% 100%;
              position: absolute;
              cursor: pointer;
            }
          }
        }

        .gray-p {
          color: #999999;
          font-size: 14px;
          cursor: pointer;
        }

        .tag-1 {
          font-style: normal;
          cursor: pointer;

          .tag-red {
            padding: 10px;
            color: #ffffff;
            background: #FE273B;
            font-size: 14px;
            border-radius: 6px 0px 0px 6px;
            border: 1px solid #FE273B;
          }

          .tag-white {
            padding: 10px;
            color: #FE273B;
            background: white;
            font-size: 14px;
            border: 1px solid #FE273B;
            border-radius: 0px 6px 6px 0px;
          }
        }

        .tag-2 {
          font-style: normal;
          color: #FE273B;
          border-radius: 6px;
          border: 1px solid #FE273B;
          padding: 10px;
          margin-left: 20px;
          font-size: 14px;
          cursor: pointer;
        }
      }

      .bg-bottom {
        background: #F3F9FF;
        padding: 20px 20px;
        border-top: 1px solid rgb(22, 55, 255, 0.1);

        .bottom-p {
          margin-block-start: 0em;
          margin-block-end: 0em;

          .left-span {
            color: #666666;
            font-size: 14px;
            cursor: pointer;
          }

          .right-span {
            color: #666666;
            font-size: 14px;
            float: right;
            cursor: pointer;
          }

          .iconfont {
            color: #333333;
          }
        }
      }
    }

    .demand-title {
      margin-block-start: 0em;
      margin-block-end: 0em;
      margin-bottom: 10px;
      border-left: 3px solid #FE273B;
      padding-left: 20px;
      font-size: 16px;
      color: #333333;
      display: flex;
      font-family: SourceHanSansCN;
      cursor: pointer;
    }

    .demand-details {
      background: #ffffff;
      padding: 0px 40px 20px;

      .details-info {
        color: rgba(51, 51, 51, 0.76);
        line-height: 28px;
        font-size: 14px;
        padding: 0px 40px 0px 0px;
        cursor: pointer;
      }

      .appendix {
        font-size: 14px;
        margin-block-start: 0px;
        margin-block-end: 0px;
        padding: 10px 20px 10px 10px;
        background: #F5F5F5;
        width: fit-content;
        margin-bottom: 10px;
        cursor: pointer;

        .iconfont {
          padding-right: 10px;
          font-size: 14px;
          color: #333333;
        }
      }
    }

    .demand-bottom {
      background: #ffffff;
      padding: 30px 40px 30px;
      border: 1px solid #EDEDED;
    }

    .service-provider-list {
      margin-top: 15px;
      padding: 30px 40px 30px;
      background: #ffffff;

      .bg-purple {
        border: 1px solid #EDEDED;
        padding: 20px;

        .small-title {
          color: #333333;
          font-size: 18px;
          text-align: left;
          cursor: context-menu;
          margin-block-start: 0em;
          margin-block-end: 0em;

          .user-name {
            font-size: 16px;
            color: #333333;
          }

          .el-position {
            font-style: normal;
            font-size: 12px;
            color: #ffffff;
            background: #FF9600;
            padding: 3px 5px;
            border-radius: 4px;
            margin-left: 10px;
          }

          .right-icon {
            float: right;
            width: 30px;
            height: 30px;

            .icon-phone {
              background: url("~@/assets/img/cloud/dianhua.png");
              width: 30px;
              height: 30px;
              background-size: 100% 100%;
              position: absolute;
              cursor: pointer;
            }
          }
        }

        .gray-p {
          color: #999999;
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          word-break: break-all;
          cursor: pointer;

          .service-label {
            font-style: normal;
            font-size: 12px;
            color: #3F5FDF;
            padding: 12px;
            background: rgb(216, 232, 255, 0.34);
            margin-right: 10px;
            display: inline-block;
          }
        }

        .grid-menu {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-around;
          cursor: pointer;
          background: #F5F5F5;
          padding: 15px 0;

          .small-grid {
            text-align: center;

            .font-black {
              color: #333333;
              font-size: 16px;
              margin-block-start: 0em;
              margin-block-end: 0em;
              font-family: 'SourceHanSansCN';
            }

            .font-gray {
              color: #666666;
              font-size: 14px;
              margin-block-start: 0em;
              margin-block-end: 0em;
            }
          }
        }

        .service-time {
          color: rgba(51, 51, 51, 0.76);
          font-size: 12px;
        }
      }
    }
    .bidding-right-status {
      height: 76px;
      width: 94px;
      margin-top: -155px;
      cursor: pointer;
      float: right;
      margin-right: -45px;
      /* 状态（0：参与中，1：投标成功，2：选标失败）*/
      .status-1 {
        width: 94px;
        height: 76px;
        background: url("~@/assets/img/cloud/participating.png");
        background-size: 100% 100%;
        position: absolute;
      }

      .status-2 {
        width: 94px;
        height: 76px;
        background: url("~@/assets/img/cloud/bid_success.png");
        background-size: 100% 100%;
        position: absolute;
      }

      .status-3 {
        width: 94px;
        height: 76px;
        background: url("~@/assets/img/cloud/biddingToError.png");
        background-size: 100% 100%;
        position: absolute;
      }
    }
    .bid-right-status {
      height: 76px;
      width: 94px;
      top: -15px;
      position: absolute;
      left: 18vw;
      cursor: pointer;
      /* 状态（0：参与中，1：投标成功，2：选标失败）*/
      .status-1 {
        width: 94px;
        height: 76px;
        background: url("~@/assets/img/cloud/participating.png");
        background-size: 100% 100%;
        position: absolute;
      }

      .status-2 {
        width: 94px;
        height: 76px;
        background: url("~@/assets/img/cloud/bid_success.png");
        background-size: 100% 100%;
        position: absolute;
      }

      .status-3 {
        width: 94px;
        height: 76px;
        background: url("~@/assets/img/cloud/biddingToError.png");
        background-size: 100% 100%;
        position: absolute;
      }
    }
  }
}
</style>